import styled from "styled-components/macro";

export const StyledSpinner = styled.div(({ theme }) => ({
  border: `5px solid ${theme.color.neutral["06"]}`,
  borderTop: `5px solid ${theme.color.brandPrimary.dark}`,
  borderRadius: "50%",
  width: "50px",
  height: "50px",
  animation: "spin 1s linear infinite",
  marginTop: "10px",

  /* Safari */
  "@-webkit-keyframes spin": {
    "0%": {
      "-webkit-transform": "rotate(0deg)",
    },
    "100%": {
      "-webkit-transform": "rotate(360deg)",
    },
  },

  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export const Container = styled.div(({ center, alone }) => ({
  width: "100%",
  height: alone ? 'auto' : "calc(100vh - 64px)",
  minHeight: alone ? '0' : "300px",
  margin: alone ? '0 10px 5px 20px' : 0,
  display: "flex",
  justifyContent: center ? "center" : "unset",
  alignItems: center ? "center" : "unset",
}));
